<script setup lang="ts">
defineProps<{ theme: string }>()
const userStore = useUserStore()
const { feature } = useCountryConfig()
const { isNew } = useLayoutVersion()
</script>

<template>
  <v-theme-provider :theme="theme">
    <v-app class="bg-vm-grey-2">
      <LayoutHeader v-if="isNew" />
      <LayoutAppBar v-else />
      <LayoutMobileNavBar
        v-if="isNew && userStore.isAuthenticated"
        class="mobile-primary-menu"
      />
      <LayoutMobileMenuPrimary
        v-else-if="userStore.isAuthenticated"
        class="mobile-primary-menu"
      />
      <v-main class="bg-vm-grey-2 d-flex flex-column">
        <LayoutNavBar
          v-if="isNew && userStore.isAuthenticated"
          class="pl-3 pt-0 pr-3 menu-secondary"
        />
        <LayoutMenuSecondary
          v-else-if="userStore.isAuthenticated"
          class="pl-3 pt-0 pr-3 menu-secondary"
        />
        <LayoutPharmacyBanner v-if="userStore.isAuthenticated && feature.displayPharmacyBanner" class="menu-secondary" />
        <div class="main-wrapper d-flex flex-column flex-grow-1">
          <v-container class="main-container flex-grow-1" fluid>
            <slot />
          </v-container>
        </div>
      </v-main>
      <LayoutFooter class="mb-14 mb-md-0" />
      <GeneralScrollButton />
      <AppSnackbar class="snackbar-wrapper" />
    </v-app>
  </v-theme-provider>
</template>

<style scoped lang="scss">
  .desktop-menu {
    @media (min-width: 600px) {
      display: none;
    }
  }
  .mobile-primary-menu {
    @media (min-width: 960px) {
      display: none;
    }
  }
  .menu-secondary {
    @media (max-width: 960px) {
      display: none;
    }
  }
  .snackbar-wrapper {
    @media (max-width: 960px) {
      margin-bottom: 16px;
    }
  }
</style>
